var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 106,
    viewBox: "0 0 108 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 3H3V13.5H20.5L33.5 79.5H98V69H41L39 58.5H95L104.5 24.5C106.1 18.1 100.5 13.5 97.5 13.5H29L26.5 3Z",
    stroke: "#909099",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 96C56 99.866 52.866 103 49 103C45.134 103 42 99.866 42 96C42 92.134 45.134 89 49 89C52.866 89 56 92.134 56 96Z",
    stroke: "#909099",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M88 96C88 99.866 84.866 103 81 103C77.134 103 74 99.866 74 96C74 92.134 77.134 89 81 89C84.866 89 88 92.134 88 96Z",
    stroke: "#909099",
    strokeWidth: 6,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIcon);
export default __webpack_public_path__ + "static/media/cart-icon.986850d36ad065de2b85b0488479ee12.svg";
export { ForwardRef as ReactComponent };